export default {
  data: {
    ENDPOINT_CONFIG: [
      {
        data: [
          {
            endpointID: 'origin',
            endpointUrl: '{static_url}/station/v2/{locale}/file.json',
            id: 'origin'
          },
          {
            endpointID: 'destination',
            endpointUrl: '{static_url}/v2/destination/{iata}/file.json',
            id: 'destination'
          },
          {
            endpointID: 'oneway',
            endpointUrl: '',
            id: 'datepicker'
          },
          {
            endpointID: 'return',
            endpointUrl: '',
            id: 'datepicker'
          },
          {
            endpointID: 'dateFormat',
            endpointUrl: '{gcs_url}/dataformat/date/{locale}/file.json',
            id: 'dateFormat'
          },
          {
            endpointID: 'multiCurrency',
            endpointUrl: '{kong_url}/multicurrency/{currency}',
            id: 'multiCurrency'
          },
          {
            endpointID: 'nearestAirport',
            endpointUrl: 'https://t.airasia.com/nearestairport/airport/user',
            id: 'nearestAirport'
          },
          {
            endpointID: 'featureFlag',
            endpointUrl: '{static_url}/cosmos/featureflags/hercules/{feature_flag_env}/file.json',
            id: 'featureFlag'
          },
          {
            endpointID: 'searchDeepLink',
            endpointUrl: '{kong_url}/deeplink/v1/encryptdeeplink',
            id: 'searchDeepLink'
          },
          {
            endpointID: 'dataVisor',
            endpointUrl: '{kong_url}/bizsecrisk',
            id: 'dataVisor'
          },
          {
            endpointID: 'baseCurrency',
            endpointUrl: '{kong_url}/basecurrency/{IATA}',
            id: 'baseCurrency'
          }
        ]
      }
    ],
    aaiDisclaimer: [
      {
        data: [
          {
            cnDisclaimerLine1: 'Just a moment. We’re redirecting you to airasia.co.in in {3} seconds.',
            cnDisclaimerLine2: ' ',
            cnDisclaimerURL: 'airasia.co.in',
            countDownTimer: '5',
            newTab: 'TRUE',
            productID: 'flights',
            redirectCompanyName: 'AirAsiaIndia',
            redirectCompanyURL: 'airasia.co.in',
            redirectionUrl: ''
          }
        ]
      }
    ],
    badges: [
      {
        data: [
          {
            icon: 'locationIcon',
            label: 'City',
            type: 'city'
          },
          {
            icon: 'airplaneIcon',
            label: 'Airport',
            type: 'airport'
          },
          {
            icon: 'hoteIcon',
            label: 'Hotel',
            type: 'hotel'
          },
          {
            icon: 'golfIcon',
            label: 'Landmark',
            type: 'landmark'
          }
        ]
      }
    ],
    chinaDisclaimer: [
      {
        data: [
          {
            cnDisclaimerLine1: '请稍候，您将于 {3} 秒后由 {0} 网站跳转至中国境外网站 {1}。',
            cnDisclaimerLine2: '您的交易是直接与中国境外网站 {1} 的运营主体 {2} 构成合同关系，与亚航商务服务(广州)有限公司无关。',
            cnDisclaimerURL: 'airasia.cn',
            countDownTimer: '5',
            newTab: 'TRUE',
            productID: 'flights',
            redirectCompanyName: 'AirAsiaCom Travel Sdn Bhd',
            redirectCompanyURL: 'airasia.com',
            redirectionUrl: 'https://china.airasiago.com/lp/dailydeals?langid=2052&utm_source=airasia_web&utm_medium=product_tile&utm_campaign=SAH&utm_content=zh-CN'
          }
        ]
      }
    ],
    components: [
      {
        data0: [
          {
            iconName: '',
            id: 'heroBanner',
            label1: '',
            label2: '',
            placeholderText: '',
            redirectUrl: 'www.airasia.com',
            showInDesktop: 'FALSE',
            showInMobile: 'TRUE',
            type: 'heroBanner'
          },
          {
            iconName: '',
            id: 'trip_type',
            label1: '',
            label2: '',
            placeholderText: '',
            redirectUrl: '',
            showInDesktop: 'TRUE',
            showInMobile: 'TRUE',
            type: 'trip_type'
          },
          {
            iconName: '',
            id: 'passenger_counter',
            label1: '',
            label2: '',
            placeholderText: '',
            redirectUrl: '',
            showInDesktop: 'TRUE',
            showInMobile: 'FALSE',
            type: 'passenger_counter'
          },
          {
            iconName: '',
            id: 'promoCode',
            label1: '',
            label2: '',
            placeholderText: 'Promo code',
            redirectUrl: '',
            showInDesktop: 'TRUE',
            showInMobile: 'FALSE',
            type: 'promoCode'
          },
          {
            iconName: '',
            id: 'big_points',
            label1: 'Redeem airasia Points',
            label2: '',
            placeholderText: '',
            redirectUrl: '',
            showInDesktop: 'TRUE',
            showInMobile: 'FALSE',
            type: 'checkbox'
          },
          {
            iconName: '',
            id: 'snapCheckbox',
            label1: 'SNAP (Flights + Hotel)',
            label2: 'Check out the savings you get when adding a hotel',
            placeholderText: '',
            redirectUrl: '',
            showInDesktop: 'TRUE',
            showInMobile: 'TRUE',
            type: 'snapCheckbox'
          }
        ]
      },
      {
        data1: [
          {
            iconName: 'locationIcon',
            id: 'originDestination',
            label1: 'Flying from',
            label2: 'Going to',
            placeholderText: 'Try "{0}"',
            redirectUrl: '',
            showInDesktop: 'TRUE',
            showInMobile: 'TRUE',
            type: 'placepicker'
          },
          {
            iconName: 'calendarIcon',
            id: 'datepicker',
            label1: 'Depart',
            label2: 'Return',
            placeholderText: '',
            redirectUrl: '',
            showInDesktop: 'TRUE',
            showInMobile: 'TRUE',
            type: 'datepicker'
          },
          {
            iconName: '',
            id: 'passenger_counter',
            label1: '',
            label2: '',
            placeholderText: '',
            redirectUrl: '',
            showInDesktop: 'FALSE',
            showInMobile: 'TRUE',
            type: 'passenger_counter'
          },
          {
            iconName: '',
            id: 'promoCode',
            label1: '',
            label2: '',
            placeholderText: 'Enter Promocode',
            redirectUrl: '',
            showInDesktop: 'FALSE',
            showInMobile: 'TRUE',
            type: 'promoCode'
          },
          {
            iconName: '',
            id: 'big_points',
            label1: 'Redeem airasia Points',
            label2: '',
            placeholderText: '',
            redirectUrl: '',
            showInDesktop: 'FALSE',
            showInMobile: 'TRUE',
            type: 'checkbox'
          },
          {
            iconName: '',
            id: 'search_button',
            label1: 'Search',
            label2: '',
            placeholderText: '',
            redirectUrl: '',
            showInDesktop: 'TRUE',
            showInMobile: 'TRUE',
            type: 'button'
          }
        ]
      }
    ],
    gtmConfig: [
      {
        data: [
          {
            event: "trackEventNoEcommerce",
            eventActionClick: "click",
            eventActionView: "view",
            eventCategory: "",
            eventLabelCardClick: "",
            eventLabelHeadlineClick: "",
          },
        ],
      },
    ],
    passengerConfig: [
      {
        data: [
          {
            max: '9',
            min: '1'
          }
        ]
      },
      {
        adult: [
          {
            max: '',
            min: '1'
          }
        ]
      },
      {
        child: [
          {
            max: '',
            min: '0'
          }
        ]
      },
      {
        infant: [
          {
            max: 'adult',
            min: '0'
          }
        ]
      }
    ],
    placepickerConfig: [
      {
        cookie: [
          {
            recentSearchCookie: 'flightRecentSearch'
          }
        ]
      },
      {
        recommendedStations: [
          {
            stationName: 'Singapore'
          },
          {
            stationName: 'Kuala Lumpur'
          },
          {
            stationName: 'India'
          },
          {
            stationName: 'Europe'
          }
        ]
      }
    ],
    translations: [
      {
        data: [
          {
            adultAgeLimit: '18 years and above',
            adultPlural: 'Adults',
            adultSingle: 'Adult',
            bigLoyaltyToggleLabel: 'Redeem airasia points',
            calendarResetButton: 'Reset',
            calendarSubmitButton: 'Confirm',
            childAgeLimit: '2 to 17 years',
            childPlural: 'Children',
            childSingle: 'Child',
            guestPlural: '{{count}} Guests',
            guestSingle: '{{count}} Guest',
            heroBannerUrl: 'https://a.staticaa.com/images/web-apps/component/flight-search/Generic-Flight-Mobile-Web-Banner.png',
            infantAgeLimit: 'Below 2 years',
            infantPlural: 'Infants',
            infantSingle: 'Infant',
            loadOptions: 'Options are loading',
            lowestFareLabel: 'Lowest all-in fares in {0} for 1 adult',
            nearestAirportLabel: 'Nearest airport',
            noFareLabel: 'Unable to display the lowest fares',
            noResultLabel: 'There is no result for {0}',
            passengerModalHeaderLabel: 'Select guests and rooms',
            paxSelectorLabel: 'Guests and travel class',
            recentSearchLabel: 'Recent searches',
            roomAddButton: 'Add more rooms',
            roomPlural: 'Rooms',
            roomRemoveButton: 'Remove',
            roomSingle: 'Room',
            roomSubmitButton: 'Done',
            roomTitle: 'Room {0}',
            snapCheckboxLabel: 'Check out the savings you get when adding a hotel',
            snapCheckboxTitle: 'SNAP (Flights + Hotel)',
            tripTypeMobileHeaderLabel: 'Journey Type'
          }
        ]
      }
    ],
    tripTypeConfig: [
      {
        data: [
          {
            code: 'R',
            label: 'Return',
            selectionType: 'select',
            url: ''
          },
          {
            code: 'O',
            label: 'One way',
            selectionType: 'select',
            url: ''
          },
          {
            code: 'M',
            label: 'Multi-city',
            selectionType: 'redirect',
            url: 'https://flybeyond.airasia.com/en/landing/multicity'
          }
        ]
      }
    ]
  },
  endpointConfig: [
    {
      endpointID: 'origin',
      endpointUrl: '{static_url}/flights/station/v2/{locale}/file.json',
      id: 'origin'
    },
    {
      endpointID: 'destination',
      endpointUrl: '{static_url}/flights/v2/destination/{iata}/file.json',
      id: 'destination'
    },
    {
      endpointID: 'oneway',
      endpointUrl: '',
      id: 'datepicker'
    },
    {
      endpointID: 'return',
      endpointUrl: '',
      id: 'datepicker'
    },
    {
      endpointID: 'dateFormat',
      endpointUrl: '{static_url}/cosmos/common/date/{locale}/file.json',
      id: 'dateFormat'
    },
    {
      endpointID: 'multiCurrency',
      endpointUrl: '{kong_url}/multicurrency/{currency}',
      id: 'multiCurrency'
    },
    {
      endpointID: 'nearestAirport',
      endpointUrl: 'https://t.airasia.com/nearestairport/airport/user',
      id: 'nearestAirport'
    },
    {
      endpointID: 'featureFlag',
      endpointUrl: '{static_url}/flights/platform/featureflags/search/{feature_flag_env}/file.json',
      id: 'featureFlag'
    },
    {
      endpointID: 'searchDeepLink',
      endpointUrl: '{kong_url}/deeplink/v1/encryptdeeplink',
      id: 'searchDeepLink'
    },
    {
      endpointID: 'dataVisor',
      endpointUrl: '{kong_url}/bizsecrisk',
      id: 'dataVisor'
    },
    {
      endpointID: 'baseCurrency',
      endpointUrl: '{kong_url}/basecurrency/{IATA}',
      id: 'baseCurrency'
    },
    {
      endpointID: 'otaGeoidFunnel',
      endpointUrl: '{static_url}/flights/ota/geoid/geoids/file.json',
      id: 'otaGeoidFunnel'
    }
  ],
}
